// Montants saisis en euros dans les réglages du thème (snippets/snk-money.liquid), affichés dans la devise du
// visiteur au taux de Shopify (Shopify.currency.rate). Arrondi propre : vers le haut pour un seuil (celui qui
// atteint le montant affiché y a droit), au plus proche pour un prix.
// Format de la devise : celui de Shopify, lu sur un montant d'exemple (window.SNK_MONEY.sample).
// window.snkMoney.convert(centimes, 'up' | 'nearest') sert aussi aux scripts (barre de livraison du panier).
(() => {
  const rate = Number(window.Shopify?.currency?.rate) || 1;
  const sample = window.SNK_MONEY?.sample || '';

  // Pas d'arrondi : 5 sur le 2e chiffre (171 → 175, 1 005 866 → 1 050 000), jamais moins d'une unité
  const clean = (value, mode) => {
    if (value <= 0) return 0;
    const step = Math.max(1, 5 * 10 ** (Math.floor(Math.log10(value)) - 2));
    return (mode === 'up' ? Math.ceil : Math.round)(value / step) * step;
  };

  const format = (amount) => {
    const run = sample.match(/\d[\d.,'\s  ]*\d/);
    if (!run) return String(amount);
    const group = /\d/.test(run[0][1]) ? '' : run[0][1];
    return sample.replace(run[0], String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, group));
  };

  const convert = (cents, mode = 'nearest') => clean((cents / 100) * rate, mode);

  const apply = (root = document) => {
    root.querySelectorAll('[data-snk-money]').forEach((el) => {
      el.textContent = format(convert(Number(el.dataset.snkMoney), el.dataset.snkRound));
    });
  };

  window.snkMoney = { convert, format, apply };
  apply();
})();
